@import 'common/stylesheets/mixins/common.styl'
@import 'common/stylesheets/defaults/index'

.nps-survey-root
  border-radius $border-radius-panel
  bottom 24px
  position fixed
  right 16px
  transition bottom 0.2s $ease-in
  width 475px
  z-index $z-modal

  // TODO: Create mp-popup that does not have position absolute so that hard-coding height is not necessary.
  &.nps-survey-score-screen
    height 150px

  &.nps-survey-text-screen
    height 245px

.nps-survey-content
  padding 20px 25px 10px 25px !important

  &, *
    // This is to override box-sizing: border-box which is inherited from mp-modal in browser using the shadow
    // dom polyfill.
    box-sizing content-box

  .nps-survey-header
    color var(--primary-text-color)
    font-size $font-size-large
    font-weight $weight-bold
    width 80%

  &.nps-survey-score-screen
    .nps-survey-scores
      display flex
      justify-content space-between
      margin-top 15px

      .nps-survey-score-button
        align-items center
        background-color var(--background-color)
        border 1px solid var(--component-outline-color)
        border-radius 50%
        box-shadow 0 1px 1px 0 alpha(black, 0.2)
        color var(--secondary-text-color)
        display flex
        font-size $font-size-small
        font-weight $weight-bold
        height 28px
        justify-content center
        line-height 12px
        padding 0
        width 28px

        &:hover
          background-color var(--component-hover-color)
          box-shadow 0 1px 2px 0 alpha(black, 0.23)
          color var(--blue1)
          cursor pointer

    .nps-survey-likeliness
      color var(--tertiary-text-color)
      display flex
      font-size $font-size-small
      font-weight $weight-medium
      justify-content space-between
      margin-top 15px

  &.nps-survey-text-screen
    .nps-survey-question
      font-size $font-size-medium
      margin-top 6px

      .nps-survey-label
        color var(--secondary-text-color)
        font-weight $weight-bold

      .nps-survey-text
        color var(--tertiary-text-color)
        font-weight $weight-medium

    .nps-survey-response-text-container
      display flex

      .nps-survey-response-text
        display block
        height 120px
        margin-top 16px
        resize none
        width 100%

    .nps-survey-button-container
      display flex
      justify-content flex-end
      margin-top 10px

      .nps-survey-submit-button
        margin-left 10px

      // Needed for browsers using shadow dom polyfill since mp-button needs border-box but the content-box
      // above overriding it
      .mp-button-root *
        box-sizing border-box
